<template>
  <div class="notfound">
    <vue-particles
      color="#dedede"
      :particleOpacity="0.7"
      :particlesNumber="150"
      shapeType="circle"
      :particleSize="3"
      :lineLinked="false"
      :moveSpeed="0.17"
      :clickEffect="false"
      :hoverEffect="false"
      clickMode="push"
      class="particles"
    >
    </vue-particles>
    <div class="wrapper">
      <h1>404</h1>
      <h3><span>{{$t('Lost?')}}</span> {{$t('It seems that page not found.')}}</h3>
      <Astronaut />
      <Planet />
      <n-button type="primary" simple="" size="lg" class="home" @click.native="goHome">{{$t('Go home')}}</n-button>
    </div>
  </div>
</template>

<script>
import { Button } from '@/ui'
import Astronaut from './svg/Astronaut'
import Planet from './svg/Planet'

export default {
  components: {
    [Button.name]: Button,
    Astronaut,
    Planet
  },
  methods: {
    goHome() {
      this.$router.push('/dashboard')
    }
  }
}
</script>

<style scoped>
  .notfound {
    height: 100vh;
    overflow: hidden;
    position: relative;
    background-color: #24344c;
  }
  .particles {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 390px;
    height: 800px;
    width: 100%;
    margin: 0 auto;
    margin-top: 8vh;
  }
  .wrapper h1 {
    color: #fff;
    font-family: "Dosis", sans-serif;
    font-size: 100px;
    font-weight: 800;
  }

  .wrapper h3 {
    color: #fff;
    margin: 0px auto 30px auto;
    font-family: "Dosis", sans-serif;
    font-weight: 400;
    text-align: center;
    padding: 0 20px;
  }

  .wrapper h3 span {
    border-bottom: 3px solid #ffbb39;
  }

  .home {
    margin: 0 auto;
  }

  @media (max-width: 575.98px) {
  h1 {
    font-size: 75px;
  }
  #astronaut {
    width: 35px;
  }
}
</style>
